import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';

const AddSpeakerActions = ({
  isEdit,
  isApplyPreset,
  isLoading,
  isApplying,
  onCancel,
  onSave,
  onSaveAndApply,
  t,
}) => (
  <Box display="flex" gap={1}>
    {isEdit && (
      <CommonButton
        customStyle={{
          height: '40px',
          borderRadius: '8px',
          border: `1px solid ${COLOR.secondary[16]}`,
          '&:focus': {
            backgroundColor: 'transparent',
          },
        }}
        variant="outlined"
        textProps={{
          color: COLOR.indigo.default,
          variantText: 'body-14-semibold',
        }}
        onClick={onCancel}
      >
        {t('cancel')}
      </CommonButton>
    )}
    <CommonButton
      customStyle={{
        height: '40px',
        borderRadius: '8px',
        border: !isApplyPreset ? 'none' : `1px solid ${COLOR.secondary[16]}`,
        '&:focus': {
          backgroundColor: 'transparent',
        },
      }}
      variant={!isApplyPreset ? 'contained' : 'outlined'}
      disabled={isLoading}
      textProps={{
        color: COLOR.indigo.default,
        variantText: 'body-14-semibold',
      }}
      onClick={onSave}
      startIcon={
        isLoading && !isApplying ? (
          <CircularProgress size={20} sx={{ color: COLOR.darkGray }} />
        ) : null
      }
    >
      {t('saveName')}
    </CommonButton>
    {isApplyPreset && (
      <CommonButton
        customStyle={{
          height: '40px',
          borderRadius: '8px',
        }}
        variant="contained"
        textProps={{
          color: COLOR.indigo.default,
          variantText: 'body-14-semibold',
        }}
        onClick={onSaveAndApply}
        disabled={isLoading}
        startIcon={
          isLoading && isApplying ? (
            <CircularProgress size={20} sx={{ color: COLOR.darkGray }} />
          ) : null
        }
      >
        {t('saveAndApply')}
      </CommonButton>
    )}
  </Box>
);

export default AddSpeakerActions;
